import { defineChain } from "viem";
import { CONFIG } from "../config";

export const apechain = defineChain({
	id: 33139,
	name: "ApeChain",
	nativeCurrency: {
		decimals: 18,
		name: "APE",
		symbol: "APE",
	},
	rpcUrls: {
		default: { http: [CONFIG.RPC_URL] },
		public: { http: [CONFIG.RPC_URL] },
	},
	blockExplorers: {
		default: { name: "CalderaExplorer", url: "https://apechain.calderaexplorer.xyz" },
	},
	contracts: {
		multicall3: {
			address: "0xcA11bde05977b3631167028862bE2a173976CA11",
			blockCreated: 1,
		},
	},
});
